<template>
    <div>

        <b-button
            v-bind="buttonProps"
            @click="modalShowing = true"
        >
            {{ buttonText }}
        </b-button>
        
        <b-modal
            v-bind="modalProps"
            v-model="modalShowing"
        >
            <slot>
                Modal Content - default slot 
            </slot>
        </b-modal>
        
    </div>
</template>

<script>

export default {
    name: 'ButtonModal',
    components: {},
    mixins: [
    ],
    props: {
        buttonProps: {
            type: Object,
            required: false,
        },
        buttonText: {
            type: String,
            default: "Show Content"
        },
        modalProps: {
            type: Object,
            required: false,
        },
    },
    data: function() {
        return {
            modalShowing: false,  // v-model with the modal
        }
    },
    computed: {

    },
    mounted: function() {
        
    },
    methods: {
        // use this.apiErrorHandler(error, extraMsg, localMsg) from mixin - localMsg is bool, if true puts message in this.errorHandlingMessage

    }
}
</script>

<style>

</style>